import React, { useState } from "react";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';

import {
  Box,
  Button,
  Modal,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Style from "./feedback.module.css";
import { apiService } from "../../api/apiService";

const style = {
  position: "absolute",
  bottom: "2%",
  right: "2%",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "8px",
  p: 4,
};

const Feedback = () => {
  const { instance } = useMsal();

  interface HandleButtonShowProps {
    val: boolean;
  }
  const [buttonShow, setButtonShow] = useState(false);
  const [modalOpen, setModalOpen] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [thankYouOpen, setThankYouOpen] = useState(false);
  const [selected, setSelected] = useState<number | null>(null);
  const handleModalClose = () => {
    handleButtonShow(true);
    setModalOpen(false)
  };
  const [feedback, setFeedback] = useState<string>("");
  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);
  const handleSubmit = async () => {
    try {
      const payload = {
        rating: selected,
        feedback
      };
      await apiService("/ops/feedback", "POST", payload, undefined, instance as PublicClientApplication);
      setDialogOpen(false);
      setThankYouOpen(true);
    } catch (error) {
      console.error("Failed to save Vision N Strategy:", error);
    }
  };
  const handleThankYouClose = () => setThankYouOpen(false);

  const handleButtonShow = (val: HandleButtonShowProps["val"]) => {
    setButtonShow(val);
  };

  const handleLeaveFeedBackBtnClick = () => {
    setModalOpen(true);
    setButtonShow(false);
  }

  return (
    <>
      <Stack
        spacing={2}
        direction="column"
        sx={{
          display: buttonShow ? "flex" : "none",
          position: "fixed",
          bottom: 110,
          right: 0,
          transform: "rotate(-90deg)",
          transformOrigin: "bottom right",
          zIndex: 1000,
        }}
      >
        <Button variant="contained" color="primary" sx={{fontWeight:"bold"}}
          onClick={handleLeaveFeedBackBtnClick}>
          Feedback
        </Button>
      </Stack>
      <Modal
  className="Feedback"
  open={modalOpen}
  disableEscapeKeyDown
  hideBackdrop
  BackdropProps={{ style: { backgroundColor: "transparent" } }}
  sx={{
    pointerEvents: "none", 
  }}
>
  <Box
    sx={{
      ...style,
      pointerEvents: "auto", 
    }}
  >
    <IconButton
      aria-label="close"
      onClick={handleModalClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
    <Typography variant="h6" component="h2">
      How can we improve?
    </Typography>
    <Typography sx={{ mt: 2 }}>
      We are looking for feedback on this particular design element.
    </Typography>
    <Button
      variant="contained"
      color="primary"
      sx={{ mt: 2 }}
      onClick={handleDialogOpen}
    >
      Leave Feedback
    </Button>
  </Box>
</Modal>

      {/* Feedback Form Dialog */}
      <Dialog
      open={dialogOpen} onClose={handleDialogClose}>
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            color: "#000",
            fontWeight: "700 !important",
            fontSize: "22px !important",
            fontFamily: "Avant bold !important",
          }}
        >
          How can we improve?
        </DialogTitle>
        <DialogContent>
          <Box>
            <Typography sx={{ fontSize: "22px", fontWeight: "600", textAlign: "center" }}>
              Give us a feedback!
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                textAlign: "center",
                color: "#363636",
                mt: "10px",
              }}
            >
             How likely are you to recommend the GBS STAR Portal?
            </Typography>
          </Box>

          {/* Rating Buttons */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: "30px" }}>
            <Stack direction="row" spacing={1} className={Style.ratebtns}>
              {Array.from({ length: 11 }, (_, i) => (
              <Button
                key={i}
                variant={selected === i ? "contained" : "outlined"}
                onClick={() => setSelected(i)}
                sx={{
                color: selected === i ? "white" : "black",
                backgroundColor: selected === i ? "#000" : "transparent",
                }}
              >
                {i}
              </Button>
              ))}
            </Stack>
            </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography sx={{ color: "#7E7E7E", fontSize: "12px" }}>Not likely at all</Typography>
            <Typography sx={{ color: "#7E7E7E", fontSize: "12px" }}>Extremely likely</Typography>
          </Box>

          <Box sx={{ mt: "30px !important", maxWidth: "90%", margin: "0 auto" }}>
            <TextField
              multiline
              rows={5}
              InputProps={{
                style: {
                  color:'black'
                }
              }}
              onChange={(e) => setFeedback(e.target.value)}
              fullWidth
              label="Type in your suggestion or feedback"
              variant="outlined"
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ mb: "20px" }}>
          <Button className={Style.Btn_black} onClick={handleSubmit} variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Thank You Dialog */}
      <Dialog open={thankYouOpen} onClose={handleThankYouClose}>
        <DialogTitle></DialogTitle>
        <DialogContent>
            <Box sx={{backgroundColor: "#DEFFE3", borderRadius: "10px", width: "60px", height: "60px", display: "flex", justifyContent: "center", alignItems: "center", }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
<path d="M9.44998 17.85L3.84998 12.25L4.92498 11.175L9.44998 15.7L19.05 6.09998L20.125 7.17498L9.44998 17.85Z" fill="#0E711D"/>
</svg>
            </Box>
            <Box sx={{ mt: "20px" }}>
            <Typography sx={{ fontSize: "20px !important", fontWeight: "600", textAlign: "left" }}>
            Feedback received!
            </Typography><br/>
          <Typography sx={{ fontSize: "17px !important", fontWeight: "400", textAlign: "left", color:"#666666 !important" }}>Thank you! Your feedback has been received and is greatly appreciated. We'll carefully analyze your insights to make meaningful improvements!</Typography>
         </Box>
        </DialogContent>
        <DialogActions sx={{justifyContent:'flex-start', ml:"20px", mb: "20px"}}>
          <Button sx={{ display:"flex",
    justifyContent: "center",
borderRadius:"8px",
background: "#EFEFEF",
color:"#666666",
fontWeight: "600",
padding: "8px 14px",
fontSize: "16px !important"}} onClick={handleThankYouClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Feedback;